<template>
  <div class="el-row--flex">
    <el-date-picker
      v-model="dateRange"
      type="datetimerange"
      range-separator="至"
      format="yyyy-MM-dd"
      start-placeholder="开始日期"
      :default-time="['00:00:00', '23:59:59']"
      :picker-options="pickerOptions"
      :clearable = 'false'
      size="small"
      end-placeholder="结束日期">
    </el-date-picker>
      <div class="margin-l">
        <el-button size="mini" @click="getTimeRange">统计</el-button>
      </div>
  </div>
</template>
<script>

export default {
  inject: ['dateSearchOrder'],
  data () {
    return {
      dateRange: [],
      pickerOptions: {
        shortcuts: [
          {text: '今天',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {text: '昨天', onClick: (picker)=> {
              const end = this.$moment().subtract(1, "days").toDate();
              const start = this.$moment().subtract(1, "days").toDate();
              picker.$emit('pick', [start, end]);
            }
          },
          {text: '本周',
            onClick: (picker)=> {
              const start = this.$moment().weekday(0).toDate();
              const end = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {text: '上周',
            onClick: (picker)=> {
              const start = this.$moment().week(this.$moment().week() - 1).startOf("week").toDate();
              const end = this.$moment().week(this.$moment().week() - 1).endOf("week").toDate();
              picker.$emit('pick', [start, end]);
            }
          },
          {text: '本月',
            onClick: (picker)=> {
              const start = this.$moment().startOf('month').toDate();
              const end = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {text: '上月',
            onClick: (picker)=> {
              const start = this.$moment().month(this.$moment().month() - 1).startOf('month').toDate();
              const end = this.$moment().month(this.$moment().month() - 1).endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
      }
    };
  },
  methods: {
    getTimeRange () {
      if (this.dateRange.length > 1) {
        let startTime = this.dateRange[0].getTime()
        let endTime = this.dateRange[1].getTime()
        this.dateSearchOrder(startTime, endTime)
      }
    }
  }
};
</script>
<style scoped>
 .margin-l{
   margin-left: 8px;
 }
 /deep/ .el-date-editor.el-input__inner{
   width: 250px;
 }
 /deep/ .el-input{
   width: 100px !important;
 }
 /deep/ input{
   background: transparent !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/controls/dateTimeRangeSearch.vue